module.exports = __webpack_public_path__ + "static/img/OffshoreRSS_logo_top@2x.c23d9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/aboutUs/OffshoreRSS_logo_top@2x.png
// module id = 8Gen
// module chunks = 0